import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { validate_account_credentials } from '../../../services/auth_service.js';
import LoginScreen from './LoginScreen.jsx';
import { DefaultPageFooter } from '../../Template.jsx'
import { HeaderLayout } from '../../PageLayout.jsx'  
import { useLocalStorage } from '../../../custom_hooks.js'
import { AuthBtn } from "./EditorTemplate.jsx";
import './editor.css';

 
const LoggedInHeaderContent = ({handleLogout, username}) => {
    return (<div id="logged-in-header-content-wrapper">
        <h5 className="editor loggedin-greeting">Welcome, {username}! </h5> 
        <AuthBtn auth_action={handleLogout} text={"Log Out"} />
    </div>)
}

export const EditorRoot = ({ }) => {
  
    const [loginErrDesc, setLoginErrDesc] = useState('')
    const [user, setUser] = useLocalStorage('hbns_username', '')

    const handleLogin = async (username, password) => {
        try {
            const validation_result = await validate_account_credentials(username, password) 
            const { acct_id, secret, authentication_code, authorization_code } = validation_result
            if (authentication_code == 'pass' && authorization_code == 'pass') { 
                setUser(username)
                setLoginErrDesc('')
            } else {
                setLoginErrDesc('Incorrect login credentials')
            }
        } catch (error) {
            setLoginErrDesc('An unexpected error prevented authentication: ' + error.toString())
            console.error(error.toString)
        }
        
    };

    const handleLogout = () => { 
        setUser('') 
    }; 

    return (
        <div id="page-layout-container">
            <HeaderLayout>
                {user ?  <LoggedInHeaderContent handleLogout={handleLogout} username={user} /> 
                    : <h5 className="loggedout-msg editor">You've been logged out. Please sign in again to continue.</h5> } 
                <br/>
            </HeaderLayout>
            <main id="page-layout-main">
                {user ? <Outlet context={{ user }} />
                    : <LoginScreen handleLogin={handleLogin} errorText={loginErrDesc} />}
            </main>
            <DefaultPageFooter />
        </div>
    );
}